import { AxiosInstance } from 'axios';

type ContactReturnType = {
  show_referrer_invalid_tip: boolean;
};
const getContactServices = ({ OfficialGateWayInstance }: { OfficialGateWayInstance: AxiosInstance }) => ({
  contact(data: Record<string, any>) {
    return OfficialGateWayInstance.post<ContactReturnType>(`/contact_us`, data);
  },
});

export default getContactServices;
